<template>
    <div v-show="isAdminOverlayVisible">
        <transition name="slide">
            <div class="modal-mask" @click="hide">
                <div class="modal-dialog modal-dialog-slideout modal-lg" @click.stop>
                   <div class="modal-content  p-2">

                        <div class="modal-header">
                          <a href="javascript:void(0);" @click="hide" style="cursor: pointer;" class="text-uppercase text-muted pt-1"><img class="back_icon mr-2" src="@/assets/manager/back_button_icon.png" />Back</a>
                          <button type="button" class="close" @click="hide">
                            <span aria-hidden="true">&times;</span>
                          </button>
                        </div>                  

                        <div class="modal-body">                      
                          <AddMentee ref="AddMenteeModal" v-show="modalFormToLoad == 'add_mentee'" />
                          <EditMentee ref="EditMenteeModal" v-show="modalFormToLoad == 'edit_mentee'" /> 
                          <AddMentor ref="AddMentorModal" v-show="modalFormToLoad == 'add_mentor'" form_type="add_mentor" @closeMentorModal="hide" />                          
                          <AddMentor ref="AddManagerModal" v-show="modalFormToLoad == 'add_manager'" form_type="add_manager" @closeMentorModal="hide" />                          
                          <EditMentor ref="EditUserModal" v-show="modalFormToLoad == 'edit_user'" form_type="edit_user" @closeMentorModal="hide" />
                        </div>

                        <div class="modal-footer"></div>

                  </div>

                </div>                
            </div>
        </transition>
    </div>
</template>
<script>
import axios from 'axios';
import AddMentee from './add_mentee.vue';
import EditMentee from './edit_mentee.vue';
import AddMentor from './add_mentor.vue';
import EditMentor from './edit_mentor.vue';
import router from '../../router/index';

export default {
    props: ['isAdminOverlayVisible', 'modalFormToLoad', 'totalLicense'],
    data() {
        return {
            
        }
    },
    components: {
        AddMentee,
        EditMentee,
        AddMentor,
        EditMentor,
    },
    methods: {
      hide() { 
          this.$parent.closeSidebar();
      },
      preLoadEditFormData(menteeId) {          
          this.$refs.EditMenteeModal.getMenteeData(menteeId);                   
      },
      preLoadFormData() {
          this.$refs.AddMenteeModal.getMentorLists();
          this.$refs.AddMenteeModal.getPathwayLists();     
      },      
      setupForm(type) {
        if (type == 'manager') {
          this.$refs.AddManagerModal.setupForm(type);  
        } else {
          this.$refs.AddMentorModal.setupForm(type);
        }
      },
      getEditUser(type, id) {
        this.$refs.EditUserModal.userType = type;
        this.$refs.EditUserModal.getEditUser(type, id);
      },
      resetAddMentorForm() {
        this.$refs.AddMentorModal.doFormReset();
      },
      resetAddManagerForm() {
        this.$refs.AddManagerModal.doFormReset();
      },
      resetEditUserForm() {
        this.$refs.EditUserModal.doFormReset();
      },
    },
}
</script>
<style scoped>

.back_icon { width: 14px; }
::-webkit-scrollbar {
    width: 0;  /* Remove scrollbar space */
    background: transparent;  /* Optional: just make scrollbar invisible */
}
.modal-mask {
    position: fixed;
    z-index: 1001;
    top: 59px;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, .5);
    transition: opacity .3s ease;
    overflow-y: scroll;
}
.modal-dialog {
  animation: slide-in 1s forwards;
  -webkit-animation: slide-in 1s forwards;
}

@keyframes slide-in {
  0% {
    -webkit-transform: translateX(100%);
  }
  100% {
    -webkit-transform: translateX(0%);
  }
}

@-webkit-keyframes slide-in {
  0% {
    transform: translateX(100%);
  }
  100% {
    transform: translateX(0%);
  }
}
.modal-dialog {
  max-width: 90%;
}
@media (min-width: 992px) {
    .modal-lg, .modal-xl { width: 650px; }
}
@media (max-width: 576px){ 
    .modal-dialog.modal-dialog-slideout { width: 80% }
}
.modal-dialog-slideout {
    min-height: 100%; margin: 0 0 0 auto; background: #fff; 
}
.modal-dialog-slideout .modal-content{ border: 0; }

/* custom css */
.modal-header { border-bottom: none; }
.modal-footer { border-top: none; }
.modal-goback { font-size: 24px; margin: 5px 10px 0 0; cursor: pointer; }
.modal-title { font-weight: 900; }
.modal-sub-title { font-size: 12px; font-weight: 500; }
.active:after {
    content: "";
    display: block;
    margin: 0;
    width: 50%;
    padding-top: 10px;
    border-bottom: 2px solid #00acee;
}
.offcanvas_header { float: left; font-weight: 900; cursor: pointer; margin-top: 15px; }
.offcanvas_heading_1 { width: 20%; }
.offcanvas_heading_2 { width: 15%; }
.offcanvas_heading_3 { width: 20%; }
.offcanvas_heading_4 { width: 15%; }
.offcanvas_heading_5 { width: 15%; }
.offcanvas_heading_6 { width: 15%; }
.offcanvas_tab_body { width: 100%; margin: 15px 0; }
.dbAddNewUserBtn {
  color: #FFF;
  background-color: #00acee;
  border: 1px solid #00acee;
  border-radius: 10px;
  font-size: 13px;
  font-weight: 900;
}
.dbAddNewUserBtn:active, .dbAddNewUserBtn:focus, .dbAddNewUserBtn:hover {
  color: #FFF !important;
  background-color: #00acee !important;
  border: 1px solid #00acee !important;
}
.text-green { color: #28a745; font-weight: 900; }
.text-red { color: #dc3545; font-weight: 900; }

.maheading_1 { width: 5%; }
.maheading_2 { width: 75%; }
.maheading_3 { width: 20%; }
/* Small Devices */
@media (min-width: 320px) and (max-width: 991px) { 
  .modal-container {
    width: 100%;
  }
}
.maheading_3 .close { padding: 0px !important; }
</style>


// WEBPACK FOOTER //
// src/components/manager/adminconsole_overlay_sidebar.vue